import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReportTypeDropdown, IReportTypeState } from "../../../types/report/ReportTypes";

export const initialState: IReportTypeState = {
  reportTypeDropdown: []
};

export const reportTypeSlice = createSlice({
  name: 'reportType',
  initialState,
  reducers: {
    loadingReportTypeDropdown: (state, action: PayloadAction<IReportTypeDropdown[]>) => {
      state.reportTypeDropdown = action.payload;
    },
  }
});

export const { loadingReportTypeDropdown } = reportTypeSlice.actions;

export default reportTypeSlice.reducer;
